import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

export const nudgeKeys = {
  all: ['nudges'] as const,
  activity: () => [...nudgeKeys.all, 'activity'] as const,
};

/**
 * Every user's nudges planned for the next 24 hours and sent or skipped in the
 * last 24. Refreshes each minute: the engine ticks about that often.
 */
export function useNudgeActivity() {
  return useQuery({
    queryKey: nudgeKeys.activity(),
    queryFn: () => adminClient.summarizeNudgeActivity(),
    refetchInterval: 60_000,
  });
}
